import loadable from '@loadable/component';
import { LoadableFunctionalComponent } from '../../../../../../../utils/index.ts';
import { SmallButtonLoader } from '../../../../../../../shared/index.ts';
import { ButtonViewProps } from '../../../../../types.ts';

export const SmallButton = loadable(() => import('./component/index.tsx'), {
  resolveComponent: (components) => components.SmallButtonComponent,
  fallback: <SmallButtonLoader />,
}) as LoadableFunctionalComponent<ButtonViewProps>;
